import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: 50,
    transition: 'opacity 0.3s ease'
  },
  disabledContainer: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  methodType: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  banksContainer: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  bankOption: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    border: '1px solid transparent',
    backgroundColor: 'white',
    flex: 1,
    transition: 'all 0.2s ease'
  },
  selectedBank: {
    border: `1px solid ${theme.palette.grey[800]}`
  },
  disabledBank: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  termsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  bankIcon: {
    width: 24,
    height: 24
  },
  switch: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  uploadBox: {
    border: '1px dashed #ccc',
    borderRadius: 8,
    padding: theme.spacing(3),
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
    cursor: 'pointer'
  },
  uploadedFileContainer: {
    marginLeft: 10
  }
}))

export default useStyles
